import { Table, TableColumnsType } from 'antd';
import { FC, ReactNode, useMemo } from 'react';
import { ICacUsageMetricValues } from '../../../models/statistics.model';

interface IProps {
  /** '직영 소계' | '가맹 소계' */
  divisionLabel: string;
  /** '{캠퍼스명} 합계' */
  campusLabel: string;
  canbAll?: Partial<ICacUsageMetricValues>;
  divisionSum?: Partial<ICacUsageMetricValues>;
  campus?: Partial<ICacUsageMetricValues>;
}

interface IRow {
  key: string;
  label: string;
  canbAll?: number;
  divisionSum?: number;
  campus?: number;
}

const fmtPct = (n: number | null | undefined) => {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  return `${n.toLocaleString('ko-KR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
};

const AlignRightWrap: FC<{ children: ReactNode }> = ({ children }) => (
  <div style={{ textAlign: 'right' }}>{children}</div>
);

/**
 * 캠퍼스 권한 전용 — CANB 전체 / 직영(가맹) 소계 / 캠퍼스 합계 사용률 비교 매트릭스(3×3).
 */
const CacRatioMatrix: FC<IProps> = ({
  divisionLabel,
  campusLabel,
  canbAll,
  divisionSum,
  campus,
}) => {
  const rows: IRow[] = useMemo(
    () => [
      {
        key: 'usageRate',
        label: '사용률',
        canbAll: canbAll?.usageRate,
        divisionSum: divisionSum?.usageRate,
        campus: campus?.usageRate,
      },
      {
        key: 'uniqueStudentRate',
        label: '학생 고유 사용률',
        canbAll: canbAll?.uniqueStudentRate,
        divisionSum: divisionSum?.uniqueStudentRate,
        campus: campus?.uniqueStudentRate,
      },
      {
        key: 'homeroomUniqueRate',
        label: '담임 고유 사용률',
        canbAll: canbAll?.homeroomUniqueRate,
        divisionSum: divisionSum?.homeroomUniqueRate,
        campus: campus?.homeroomUniqueRate,
      },
    ],
    [canbAll, divisionSum, campus],
  );

  const columns: TableColumnsType<IRow> = useMemo(
    () => [
      {
        title: '',
        dataIndex: 'label',
        key: 'label',
        width: 160,
      },
      {
        title: 'CANB 전체',
        dataIndex: 'canbAll',
        key: 'canbAll',
        render: (v) => <AlignRightWrap>{fmtPct(v)}</AlignRightWrap>,
      },
      {
        title: divisionLabel,
        dataIndex: 'divisionSum',
        key: 'divisionSum',
        render: (v) => <AlignRightWrap>{fmtPct(v)}</AlignRightWrap>,
      },
      {
        title: campusLabel,
        dataIndex: 'campus',
        key: 'campus',
        render: (v) => <AlignRightWrap>{fmtPct(v)}</AlignRightWrap>,
      },
    ],
    [divisionLabel, campusLabel],
  );

  return (
    <div className="comm-table__area mb-3">
      <Table<IRow>
        rowKey="key"
        columns={columns}
        dataSource={rows}
        pagination={false}
      />
    </div>
  );
};

export default CacRatioMatrix;
